import { injectable, unmanaged } from 'inversify';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import type { AxiosInstance } from 'axios';
import { apiHttpClient as baseHttpClient } from '../services/httpClients/apiHttpClient';
import { combineUrls } from './utils';

@injectable()
export class BaseRepository {
  protected httpClient: AxiosInstance;

  constructor(@unmanaged() serviceUrl: string, httpClient: AxiosInstance = baseHttpClient) {
    const getUrl = (url: string) => combineUrls(serviceUrl, url);

    this.httpClient = new Proxy(httpClient, {
      get(target, prop, receiver) {
        // decorate first argument with base service url
        if (typeof target === 'function') {
          return (..._args: never[]) => {
            const [path, ...rest] = _args;

            // @ts-ignore
            return Reflect.apply(target[prop], undefined, [getUrl(path), ...rest]);
          };
        }

        return Reflect.get(target, prop, receiver);
      },
    });
  }
}
